import { takeEvery } from 'redux-saga/effects';
import { select, call } from 'typed-redux-saga';
import { IState } from '../reducers';
import * as selectors from '../selectors';
import track, { ElevioEvents } from '@elevio-kb/eventer';
import * as PageActions from '../actions/page';
import * as SearchActions from '../actions/search';

const getSearchDetails = (
  state: IState
): {
  searchTerm: string | null;
  totalAmount: number | null;
  articleIds: Array<string>;
} => {
  const searchTerm = state.search.searchedTerm;
  const totalAmount = state.search.totalCount;
  const articleIds = state.search.results?.map((a) => a.id) || [];
  return { searchTerm, totalAmount, articleIds };
};

export function* sendHomePageEvent() {
  yield* call(track, ElevioEvents.pageViewIndex());
}

export function* sendArticlePageEvent(articleId: string) {
  let articlePage = yield* select(selectors.getArticlePageData, articleId);
  if (articlePage && articlePage.article) {
    track(
      ElevioEvents.pageViewArticle({
        event_ctx_id: articleId,
        event_ctx_title: articlePage.article.title,
      })
    );
  }
}

export function* sendCategoryPageEvent(categoryId: string) {
  let categoryPage = yield* select(selectors.getCategoryPageData, categoryId);
  if (categoryPage && categoryPage.category) {
    track(
      ElevioEvents.pageViewCategory({
        event_ctx_categoryId: categoryId,
        event_ctx_title: categoryPage.category.title,
      })
    );
  }
}

export function* sendSearchResultsEvent(searchTerm: string, page: number) {
  // KP: just until quiten down TS until start to use.
  page;
  const results = yield* select(getSearchDetails);

  // Results match
  if (results && results.searchTerm === searchTerm) {
    track(
      ElevioEvents.searchQuery({
        event_ctx_queryTerm: searchTerm,
        event_ctx_totalResults: results.totalAmount || 0,
        event_ctx_articleIds: results.articleIds,
      })
    );
    return;
  }
}

export function* watchPageMount() {
  yield takeEvery(PageActions.ActionTypes.PAGE_NAV_COMPLETE, function* (
    action: ReturnType<typeof PageActions.Actions.pageNavComplete>
  ) {
    if (action.payload.pageType === 'home') {
      yield* call(sendHomePageEvent);
    }

    if (action.payload.pageType === 'article') {
      yield* call(sendArticlePageEvent, action.payload.articleId);
    }

    if (action.payload.pageType === 'category') {
      yield* call(sendCategoryPageEvent, action.payload.categoryId);
    }

    if (action.payload.pageType === 'search') {
      yield* call(sendSearchResultsEvent, action.payload.searchTerm, 1);
    }
  });
}

export function* watchSearchResultClick() {
  yield takeEvery(SearchActions.ActionTypes.SEARCH_RESULT_CLICK, function* (
    action: ReturnType<typeof SearchActions.Actions.searchResultClick>
  ) {
    const searchTerm = yield* select(
      (state: IState) => state.search.searchedTerm
    );

    if (!searchTerm) return;
    const { articleId, title, index } = action.payload;
    yield* call(
      track,
      ElevioEvents.searchClick({
        event_ctx_query: searchTerm,
        event_ctx_id: articleId,
        event_ctx_index: index,
        event_ctx_title: title,
      })
    );
  });
}
